import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class IconService {
  private readonly iconMap: Record<string, string> = {
    'API': 'fa-solid fa-code',
    'Account': 'fa-solid fa-user',
    'Game Modes': 'fa-solid fa-sliders',
    'Game Mode Operations': 'fa-solid fa-list-check',
    'Admin': 'fa fa-user-shield',
    'Applications': 'fa-solid fa-layer-group',
    'Bans': 'fa fa-user-slash',
    'Ban Report': 'fa fa-file-alt',
    'Contact': 'fa-solid fa-envelope',
    'Dashboard': 'fa-solid fa-gauge-high',
    'Database Communicator': 'fa-solid fa-database',
    'Discord Bot': 'fa-brands fa-discord',
    'Epic Games': 'fa-brands fa-epic-games',
    'Games': 'fa-solid fa-gamepad',
    'Servers': 'fa-solid fa-server',
    'Kingless Realms': 'fa-solid fa-crown',
    'Learn': 'fa-solid fa-book',
    'Leaderboards': 'fa-solid fa-ranking-star',
    'Log out': 'fa-solid fa-right-from-bracket',
    'Login': 'fa-solid fa-right-to-bracket',
    'Logs': 'fa-solid fa-clipboard-list',
    'Matchmaking': 'fa-solid fa-people-arrows',
    'News': 'fa-solid fa-newspaper',
    'OpenAPI': 'fa-solid fa-diagram-project',
    'Permissions': 'fa-solid fa-key',
    'Player Lookup': 'fa-solid fa-search',
    'Plugins': 'fa-solid fa-puzzle-piece',
    'Polling Tick Rates': 'fa-solid fa-stopwatch',
    'Product & Solutions': 'fa-solid fa-box-open',
    'Rate Limit Counters': 'fa-solid fa-gauge-high',
    'Register': 'fa-solid fa-user-plus',
    'Release Pipeline': 'fa-solid fa-rocket',
    'Required': 'fas fa-asterisk',
    'Support': 'fa-solid fa-headset',
    'Steam': 'fa-brands fa-steam',
    'Thumper Chess': 'fa-solid fa-chess-knight',
    'Thumper Games Pro': 'fa fa-gem',
    'Thumper Games Score': 'fa fa-chart-line',
    'Verification': 'fa fa-id-card',
    'Videos': 'fa-solid fa-video'
  };

  constructor() { }

  getIconClass(label: string): string {
    return this.iconMap[label] || 'fa-solid fa-circle-question';
  }
}
